const homepage = {
  SectionTitles: {
    DiscoverOurProducts: "Discover Our Products",
    DiscoverEmerson: "Discover Emerson Ecologics",
    FeaturedBrands: "Featured brands",
    FeaturedProducts: "Featured Products",
  },
  subHeading: {
    DiscoverEmersonSubHeading: "Transform the way you recommend supplements",
  },
  sectionContent: {
    DiscoverEmersonContent:
      "Write and manage optimal supplement plans that patients can order right to their doors. Join 100,000+ practitioners on Fullscript with a free account today.",
  },
  common: {
    FeaturedBrands: "Featured Brands",
    FeaturedProducts: "Featured Products",
    FeaturedConditions: "Featured Conditions",
    Wellevate: "Wellevate",
    Education: "Education",
    Quality: "Quality",
    Shop: "Shop",
    Fullscript: "Fullscript",
    LearnMore: "Learn More",
  },
  rso: {
    TryFullscript: "Access tools to promote patient adherence with a free Fullscript account.",
    AccessFs: "Access Fullscript",
  },
};

export { homepage };
